import React, { useState } from 'react'

import styled from 'styled-components'

import { Hero, VideoPlayButton } from '../../Common'
import { VideoModal } from './VideoModal'

export const VideoBlock = ({ pageBlock }) => {
    const [showModal, setShowModal] = useState(false)
    const [videoUrl, setVideoUrl] = useState('')

    const openModal = video_url => {
        setShowModal(true)
        setVideoUrl(video_url)
    }

    const closeModal = () => setShowModal(false)

    return (
        <>
            <ThumbnailHero background={pageBlock.image}>
                <VideoPlayButton onClick={() => openModal(pageBlock.video_url)} />
                <VideoModal
                    url={pageBlock.video_url}
                    showModal={showModal}
                    closeModal={closeModal}
                    full={true} />
            </ThumbnailHero>
        </>
    )
}

const ThumbnailHero = styled(Hero)`
    background: center / cover no-repeat url(${props => props.background});
`
